import SearchIcon from '@mui/icons-material/Search'
import { Autocomplete, Button, TextField } from '@mui/material'
import { Box } from '@mui/system'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { INITIAL_ROWS_PER_PAGE } from '../../Products/components/TableDataPagination'

export interface FiltrosFac {
  idFacturacionJob: number
  idContratoCtaCte: number
  transactionId: number
  numeroDocumento: string
  cae: number
  estado: number
}

/* eslint-disable react/prop-types */
const FiltrosFacturacion: React.FC<{
  loading: boolean
  isMobile: boolean
  estados: {
    nombre: string
    id: number
  }[]
  filtros: FiltrosFac
  setFiltros: (f: FiltrosFac) => void
  handleFormSubmit: (pagina: number, size: number) => Promise<void>
}> = ({ loading, isMobile, estados, filtros, setFiltros, handleFormSubmit }) => {
  const Fields: { field: keyof FiltrosFac; label: string }[] = [
    { field: 'idFacturacionJob', label: 'ID Facturación Job' },
    { field: 'idContratoCtaCte', label: 'ID Contrato CtaCte' },
    { field: 'transactionId', label: 'ID Transacción' },
    { field: 'numeroDocumento', label: 'Nro. Documento' },
    { field: 'cae', label: 'CAE' }
  ]

  const handleFieldChange = (field: keyof FiltrosFac) => (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value
    if (field === 'numeroDocumento') setFiltros({ ...filtros, numeroDocumento: val })
    if (val === '' || /^\d+$/.test(val)) {
      setFiltros({ ...filtros, [field]: val === '' ? 0 : Number(val) })
    }
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          width: '100%',
          gap: '0.6rem',
          margin: '1rem 0',
          padding: '0 0.5rem'
        }}
      >
        {/* Autocomplete de Estados */}
        <Autocomplete
          options={estados}
          disabled={loading}
          getOptionLabel={(option) => option.nombre}
          value={estados.find((e) => e.id === filtros.estado) ?? null}
          onChange={(_, newValue) => setFiltros({ ...filtros, estado: newValue?.id || null })}
          onKeyDown={(e) => {
            if (e.key === 'Enter') handleFormSubmit(0, INITIAL_ROWS_PER_PAGE)
          }}
          renderInput={(params) => <TextField {...params} label="Estado" size="small" />}
          sx={{ flex: 1, minWidth: 150 }}
        />

        {/* Campos numéricos */}
        {Fields.map(({ field, label }) => (
          <TextField
            key={field}
            disabled={loading}
            label={label}
            size="small"
            value={filtros[field] || ''}
            onChange={handleFieldChange(field)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleFormSubmit(0, INITIAL_ROWS_PER_PAGE)
            }}
            inputProps={{ ...(field !== 'numeroDocumento' && { inputMode: 'numeric', pattern: '[0-9]*' }) }}
            sx={{ flex: 1, minWidth: 130 }}
          />
        ))}

        {/* Botón Buscar */}
        <Button
          disabled={loading}
          variant="contained"
          startIcon={<SearchIcon />}
          onClick={() => handleFormSubmit(0, INITIAL_ROWS_PER_PAGE)}
          sx={{ height: 40, whiteSpace: 'nowrap', flexShrink: 0 }}
        >
          Buscar
        </Button>
      </Box>
    </LocalizationProvider>
  )
}

export default FiltrosFacturacion
